/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react';

import useCommunicationsHubContextView from './UseCommunicationsHubContextView';
import NavLinks from './NavLinks';

import Headings from '@usas/ui-web/components/headings/Headings';
import MobileContextBasedNav from '@usas/ui-web/components/contextBasedNav/MobileContextBasedNav';
import LargeContextBasedNav from '@usas/ui-web/components/contextBasedNav/LargeContextBasedNav';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const CommunicationsHubContextView = ({ children }) => {
  const { onHomeClicked }
    = useCommunicationsHubContextView();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <button className={global.HeaderButton} onClick={onHomeClicked}>
            <Headings.H3
              className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
              excludeBar={true}>
              Communications Hub
            </Headings.H3>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <hr className="usas-bar-turmeric" />
        </div>
      </div>
      <div className="row">
        <div className="visible-xs col-xs-12">
          <MobileContextBasedNav taxonomyName="CommunicationsHub" />
        </div>
        <div className="hidden-xs col-xs-12">
          <LargeContextBasedNav taxonomyName="CommunicationsHub" homeRoute={NavLinks.COMMUNICATIONS_HUB_INBOX} />
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default CommunicationsHubContextView;